import React, { FC } from 'react';
import List from 'components/fields/components/List';

const Screen: FC = () => (
  <List
    entityName="fields"
    entityEndpoint="fields"
  />
);

export default Screen;
